import React from 'react';

import { InfoBox } from '@infoods/lifebase-ui';
import classes from './CurrentPlanWidget.module.scss';
import {
  BillingPeriodType,
  BillingPeriodTypeChip,
} from '../../../../../../../../payment';

type CurrentPlanWidgetProps = {
  subscriptionName: string;
  billingPeriodType: BillingPeriodType;
};

const CurrentPlanWidget = ({
  subscriptionName,
  billingPeriodType,
}: CurrentPlanWidgetProps) => {
  return (
    <InfoBox title="Current Active Plan" customMargin>
      <p className={classes.title}>{subscriptionName}</p>
      <BillingPeriodTypeChip billingPeriodType={billingPeriodType} />
    </InfoBox>
  );
};

export { CurrentPlanWidget };
